function Privacy() {
    return (
      <div className="px-3 mt-2 space-y-4">
        <h1 className="text-2xl font-bold">WE:U 개인정보 처리방침</h1>
        <p>
          주식회사 케이씨코퍼레이션(이하 &apos;회사&apos;)은 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고
          이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
        </p>
  
        <h2 className="text-xl font-semibold">제1조 (개인정보의 처리 목적)</h2>
        <p>
          회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는
          이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한
          조치를 이행할 예정입니다.
        </p>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            <strong>회원 가입 및 관리</strong> – 본인확인, 개인 식별, 부정이용 방지 등
          </li>
          <li>
            <strong>블로그 체험단 서비스 제공</strong> – 체험단 선정, 제품 발송, 활동 이력 관리 등
          </li>
          <li>
            <strong>마케팅 및 광고에의 활용</strong> – 이벤트 안내, 광고 제공 등
          </li>
          <li>
            <strong>민원 처리</strong> – 민원인의 신원 확인, 결과 통보 등
          </li>
        </ul>
  
        <h2 className="text-xl font-semibold">제2조 (개인정보의 처리 및 보유 기간)</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            <strong>회원 정보:</strong> 회원 탈퇴 시까지 보유, 탈퇴 시 즉시 삭제
          </li>
          <li>
            <strong>법령에 따른 보존:</strong> 계약, 결제, 민원 등 관련 법령에 따라 3~5년 보존
          </li>
        </ul>
  
        <h2 className="text-xl font-semibold">제3조 (처리하는 개인정보의 항목)</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>필수: 이름, 이메일, 휴대폰번호, 블로그 주소</li>
          <li>자동 수집: IP주소, 쿠키, 이용기록 등</li>
        </ul>
  
        <h2 className="text-xl font-semibold">제4조 (개인정보의 제3자 제공)</h2>
        <p>현재 회사는 제3자에게 개인정보를 제공하고 있지 않습니다.</p>
  
        <h2 className="text-xl font-semibold">제5조 (개인정보처리의 위탁)</h2>
        <p>현재 회사는 개인정보 처리를 위탁하고 있지 않습니다.</p>
  
        <h2 className="text-xl font-semibold">
          제6조 (정보주체와 법정대리인의 권리·의무 및 행사방법)
        </h2>
        <p>
          정보주체는 회사에 대해 언제든지 열람·정정·삭제·처리정지 등의 권리를 행사할 수 있습니다. 본인 또는
          대리인을 통해 서면, 이메일 등으로 요청 가능합니다.
        </p>
  
        <h2 className="text-xl font-semibold">제7조 (개인정보의 파기)</h2>
        <p>
          보유기간 경과 또는 처리목적 달성 시 지체없이 파기합니다. 전자 파일은 복구 불가능한 방식으로 삭제되며,
          출력물은 분쇄 또는 소각합니다.
        </p>
  
        <h2 className="text-xl font-semibold">제8조 (개인정보의 안전성 확보조치)</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>관리적 조치: 내부관리계획 수립, 정기교육</li>
          <li>기술적 조치: 접근제어, 암호화</li>
          <li>물리적 조치: 자료보관실 접근통제</li>
        </ul>
  
        <h2 className="text-xl font-semibold">
          제9조 (개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)
        </h2>
        <p>
          맞춤형 서비스 제공을 위해 쿠키(cookie)를 사용합니다. 사용자는 웹브라우저 설정을 통해 쿠키 저장을
          거부할 수 있습니다.
        </p>
  
        <h2 className="text-xl font-semibold">제10조 (개인정보 보호책임자)</h2>
        <p>
          ▶ 개인정보 보호책임자<br />
          - 성명: 이경철<br />
          - 직책: 대표<br />
          - 연락처: 070-7777-4556<br />
          - 이메일: kclee@weu.kr
        </p>
  
        <h2 className="text-xl font-semibold">제11조 (개인정보 열람청구)</h2>
        <p>
          ▶ 개인정보 열람청구 접수·처리 부서<br />
          - 부서명: 개인정보보호 담당부서<br />
          - 담당자: 이경철<br />
          - 연락처: 070-7777-4556<br />
          - 이메일: kclee@weu.kr
        </p>
  
        <h2 className="text-xl font-semibold">제12조 (권익침해 구제방법)</h2>
        <ul className="list-disc pl-5 space-y-2">
          <li>개인정보분쟁조정위원회: 1833-6972 / www.kopico.go.kr</li>
          <li>개인정보침해신고센터: 118 / privacy.kisa.or.kr</li>
          <li>대검찰청: 1301 / www.spo.go.kr</li>
          <li>경찰청: 182 / ecrm.cyber.go.kr</li>
        </ul>
  
        <h2 className="text-xl font-semibold">제13조 (영상정보처리기기 운영·관리에 관한 사항)</h2>
        <p>회사는 영상정보처리기기를 설치·운영하고 있지 않습니다.</p>
  
        <h2 className="text-xl font-semibold">제14조 (개인정보 처리방침 변경)</h2>
        <p>이 개인정보 처리방침은 2025년 2월 5일부터 적용됩니다.</p>
        <p>이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.</p>
      </div>
    );
  }
  
  export default Privacy;
  